<template>
  <div class="resource-info">
    <div class="resource-info_title">
      {{ $t("resource.label.label") }}
    </div>
    <div class="resource-info_line"></div>
    <div class="resource-info_detail row">
      <div class="col-3">
        <div class="resource-info_detail_title">{{ $t("resource.label.code") }}</div>
        <div class="resource-info_detail_content">{{ employee.id }}</div>
      </div>
      <div class="col-3">
        <div class="resource-info_detail_title">{{ $t("resource.label.name") }}</div>
        <div class="resource-info_detail_content">{{ employee.name }}</div>
      </div>
      <div class="col-6">
        <div class="resource-info_detail_title">{{ $t("resource.label.department") }}</div>
        <div class="resource-info_detail_content">{{ employee.foot }}</div>
      </div>
      <div class="col-3">
        <div class="resource-info_detail_title">{{ $t("resource.label.department_pos") }}</div>
        <div class="resource-info_detail_content">{{ employee.division }}</div>
      </div>
      <div class="col-3">
        <div class="resource-info_detail_title">{{ $t("resource.label.position") }}</div>
        <div class="resource-info_detail_content">{{ employee.position_name }}</div>
      </div>
      <div class="col-6">
        <div class="resource-info_detail_title">{{ $t("resource.label.skills") }}</div>
        <div class="resource-info_detail_content">{{ skills }}</div>
      </div>
      <div class="col-3">
        <div class="resource-info_detail_title">{{ $t("resource.label.status") }}</div>
        <div
          class="resource-info_detail_content"
          :style="employee.status_work ? { 'color': '#F03D3E' } : { 'color': '#17A896' }"
          v-show="renderSuccess"
        >
          {{ employee.status_work ? $t("resource.status_work.free") : $t("resource.status_work.no_free") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from "vuex";
import ResourceInfo from "./ResourceInfo";
import moment from "moment";

export default {
  name: "ResourceInfo",
  components: {
    ResourceInfo
  },
  computed: {
    ...mapGetters({
      employee: "employee/employee"
    }),
  },
  async created() {
    await this.$store.dispatch("employee/showEmployee", {
      employeeId: this.$route.params.id,
      startDate: moment().weekday() === 1 ? moment().clone().subtract(1, 'week').weekday(1).format("YYYY-MM-DD") :
        moment().clone().weekday(1).format("YYYY-MM-DD"),
      endDate: moment().weekday() === 1 ? moment().clone().subtract(1, 'week').weekday(5).format("YYYY-MM-DD") :
        moment().clone().weekday(5).format("YYYY-MM-DD")
    });
    this.renderSuccess = true;
    this.getSkills();
  },
  data() {
    return {
      skills: "",
      renderSuccess: false
    }
  },
  beforeDestroy() {
    this.setStartEndDate({
      start_date: moment().subtract(18, "days").format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
    });
  },
  methods: {
    ...mapActions("project", ["setStartEndDate"]),
    getSkills() {
      this.skills = "";
      Object.keys(this.employee.employee_skill).forEach(key => {
        if (this.employee.employee_skill[key].name) {
          this.skills = this.skills + this.employee.employee_skill[key].name;
          if (Number(key) !== Object.keys(this.employee.employee_skill).length - 1) {
            this.skills = this.skills + ", ";
          }
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.resource-info {
  background: #ffffff;
  padding: 0 30px;
  &_title {
    padding: 24px 0;
    font-family: "Roboto";
    font-size: 18px;
    font-weight: 700;
    line-height: 21px;
    color: #303C54;
  }
  &_line {
    border-bottom: #CFCFCF solid 1px;
  }
  &_detail {
    padding: 24px 0;
    &_title {
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      font-family: "Helvetica Neue";
      color: #A5A5A5;
    }
    &_content {
      padding: 10px 0;
      font-weight: 700;
      font-size: 24px;
      line-height: 30px;
      font-family: "Helvetica Neue";
      color: #303C54;
    }
  }
}
</style>
